import { HexToHueConverter } from '../../../../../../../helper/ColorToHueConverter';
import { useEffect, useMemo, useState } from 'react';
import { staticComponentValueConverter } from '../StaticComponentValues';
import { changeIframeOnClick } from '../../../../../../../helper/Helpers';

function BottomBar_12({ item, activeThemePageId }) {
  const customization = staticComponentValueConverter(item?.customization);
  const [activeBottomBar, setActiveBottomBar] = useState(0);
  const bottomBarFilter = useMemo(() => HexToHueConverter(customization?.iconColor), [customization?.iconColor]);
  const bottomBarFilterActive = useMemo(
    () => HexToHueConverter(customization?.selectedIconColor),
    [customization?.selectedIconColor],
  );
  const cartIconColor = useMemo(() => HexToHueConverter(customization?.cartIconColor), [customization?.cartIconColor]);

  useEffect(() => {
    const pageId = activeThemePageId;
    const pageIdIndex = customization?.items_2?.findIndex(item => {
      const pointTo = item?.pointTo?.pointTo;
      if (pointTo?.includes(pageId)) {
        return item;
      }
    });
    if (pageIdIndex !== -1) {
      return setActiveBottomBar(pageIdIndex);
    }
    const pageMainIndex = customization?.items_2?.findIndex(item => {
      const pointTo = item?.pointTo?.pointTo;
      if (pointTo?.includes('Main')) {
        return item;
      }
    });
    setActiveBottomBar(pageMainIndex > -1 ? pageMainIndex : 0);
  }, [activeThemePageId]);
  return (
    <div
      id="bottomBar"
      className="shrink-0 w-full flex flex-row items-center justify-center gap-5 bg-gradient-to-t from-[rgba(0,0,0,0.6)] to-transparent"
      style={{
        position: 'absolute',
        bottom: '0',
        backgroundColor: 'transparent',
        borderBottomRightRadius: customization?.bottomRadius,
        borderBottomLeftRadius: customization?.bottomRadius,
        paddingBottom: '20px',
        zIndex: 22,
        paddingTop: '10px',
      }}
    >
      <div
        style={{
          color: 'black',
          background: customization?.backgroundColor,
          width: '44px',
          height: '44px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: '20',
          borderRadius: '50%',
        }}
      >
        <svg width="22px" height="22px" viewBox="0 0 0.6 0.6" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0.36 0.48a0.03 0.03 0 0 1 -0.021 -0.009l-0.15 -0.15a0.03 0.03 0 0 1 0 -0.042l0.15 -0.15a0.03 0.03 0 1 1 0.042 0.042L0.252 0.3l0.129 0.129A0.03 0.03 0 0 1 0.36 0.48"
            fill="#000000"
          />
        </svg>
      </div>
      <div
        className=" flex justify-center cursor-pointer z-[20] gap-4 "
        style={{
          background: customization?.backgroundColor,
          borderRadius: '20px',
          paddingLeft: '15px',
          paddingRight: '15px',
          height: '44px',
        }}
      >
        {customization?.items_2?.slice(0, 3).map((bottomBarItem, index) => {
          return (
            <div
              class="flex justify-center  cursor-pointer  z-[20] "
              style={{}}
              onClick={() => {
                changeIframeOnClick(bottomBarItem?.pointTo?.pointTo);
                setActiveBottomBar(index);
              }}
            >
              <img
                style={{ filter: index === activeBottomBar ? bottomBarFilterActive : bottomBarFilter }}
                className="m-auto w-[22px] h-[22px] 2xl:h-[21.84px] 2xl:w-[21.84px]"
                src={bottomBarItem?.url}
                alt={'bottom bar icon'}
              />
            </div>
          );
        })}
      </div>

      {/* <div
        style={{
          color: 'black',
          backgroundColor: '#553BEB',
          width: '44px',
          height: '44px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: '20',
          borderRadius: '50%',
        }}
      >
        <svg
          width="22px"
          height="22px"
          viewBox="0 0 0.72 0.72"
          xmlns="http://www.w3.org/2000/svg"
          id="cart"
          class="icon glyph"
        >
          <path
            d="m0.66 0.217 -0.06 0.24a0.03 0.03 0 0 1 -0.026 0.023l-0.33 0.03H0.24a0.03 0.03 0 0 1 -0.03 -0.025l-0.041 -0.27L0.154 0.12H0.09a0.03 0.03 0 0 1 0 -0.06h0.064a0.06 0.06 0 0 1 0.06 0.051L0.224 0.18H0.63a0.03 0.03 0 0 1 0.024 0.011 0.03 0.03 0 0 1 0.006 0.026M0.495 0.57a0.045 0.045 0 1 0 0.045 0.045 0.045 0.045 0 0 0 -0.045 -0.045m-0.18 0a0.045 0.045 0 1 0 0.045 0.045 0.045 0.045 0 0 0 -0.045 -0.045"
            fill="#FFFFFF"
          />
        </svg>
      </div> */}

      <div
        style={{
          background: customization?.cartIconBackgroundColor,
          width: '44px',
          height: '44px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: '20',
          borderRadius: '50%',
          position: 'relative',
        }}
      >
        <img
          style={{ filter: cartIconColor }}
          className="m-auto w-[22px] h-[22px] 2xl:h-[21.84px] 2xl:w-[21.84px]"
          src={customization?.cartIcon}
          alt={'bottom bar icon'}
        />
        <div
          style={{
            position: 'absolute',
            float: 'left',
            width: '100%',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%,-50%)',
            margin: 0,
            fontSize: '10px',
            color: customization?.cartIconBackgroundColor,
          }}
        >
          1
        </div>
      </div>
    </div>
  );
}
export default BottomBar_12;
